// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1hbkP","success":"Button_success__vUGQE","error":"Button_error__15lok","primary":"Button_primary__31y4A"};